<script lang="ts" setup>
import { getCurrentInstance, computed } from 'vue';

defineOptions({
    name: 'field-text'
});

withDefaults(defineProps<{
    label?: string;
    modelValue?: string|null;
    invalidFeedback?: (value: string) => string;
    pattern?: string;
    size?: string;
    type?: string;
    placeholder?: string;
    disabled?: boolean;
    textarea?: boolean;
}>(), {
    label: null,
    type: 'text',
    placeholder: null,
    invalidFeedback: null,
    pattern: null,
    modelValue: undefined,
    size: null
});

const emit = defineEmits<{
    (e: 'update:modelValue', value: string): void
}>();

const instance = getCurrentInstance();
const uid = computed(() => `form-field-${instance.uid}`);

const update = (e: any): void =>
{
    emit('update:modelValue', e?.target?.value);
};
</script>

<template>
    <div class="form-group" :class="{invalid: invalidFeedback && invalidFeedback(modelValue)}">
        <label :for="uid" v-if="label">{{ $t(label) }}</label>
        <input v-if="!textarea" :type="type" :id="uid" class="form-control" :class="{'form-control-sm': size == 'sm', 'form-control-lg': size == 'lg'}" :placeholder="placeholder" :pattern="pattern" :value="$t(modelValue)" :disabled="disabled" @input="update">
        <textarea v-else :id="uid" class="form-control" rows="3" :class="{'form-control-sm': size == 'sm', 'form-control-lg': size == 'lg'}" :placeholder="placeholder" :pattern="pattern" :value="$t(modelValue)" :disabled="disabled" @input="update"></textarea>
        <small class="form-text text-danger" v-if="invalidFeedback && invalidFeedback(modelValue)">
            {{ $t(invalidFeedback(modelValue)) }}
        </small>
    </div>
</template>
